import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CategoryBadge({ category }) {
    if (!category)
        return null;
    return (_jsxs("span", { className: "badge bg-secondary-subtle text-secondary", children: [_jsx("i", { className: "bi bi-circle-fill me-1", style: { fontSize: '0.5rem', color: category.color || '#6c757d' } }), category.name] }));
}
export default CategoryBadge;
